<h2>{{ myTitle$ | async }}</h2>
@if (crumbs$ | async; as crumbs) {
  <span class="text-center">
    @for (crumb of crumbs; track crumb; let i = $index) {
      <span class="crumb-label">
        @if (i>0) {
          <span class="crumb-label-divider">/</span>
        }
        <span>{{crumb.label}}</span>
      </span>
    }
    @if (addCrumb$ | async; as addCrumb) {
      <span class="crumb-label">
        <span class="crumb-label-divider">/</span>
        <span>{{addCrumb.label}}</span>
      </span>
    }
  </span>
}